import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    sendAnnouncementsData: [],
    triggersData: [],
    messageData: []
}
const mutations = {
    SET_SEND_ANNOUNCEMENT_DATA(state, data) {
        state.sendAnnouncementsData = data
    },
    SET_TRIGGERS_DATA(state, data) {
        state.triggersData = data
    },
    SET_MESSAGES_DATA(state, data) {
        state.messageData = data
    }

}
const actions = {
    fetchSendAnnouncements({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/announcements/send_announcement_list')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push(res.data.message);
                } else {
                    commit('SET_SEND_ANNOUNCEMENT_DATA', res.data)
                }
            })
            .catch(error => console.log(error))
    },
    addRecipientData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/announcements/get_group_users', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    sendAnnouncement({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/announcements/submit_announcements', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchTriggers({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/announcements/triggers_list')
            .then(res => {
                Nprogress.done()
                commit('SET_TRIGGERS_DATA', res.data)
            })
            .catch(error => console.log(error))
    },
    postTrigger({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/announcements/additional_quota_offers/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('SET_TRIGGERS_DATA', response.data.message);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    applyToAllSubZoneAn({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/announcements/additional_quota_offers_subaccounts', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    restrictToAllSubZoneAn({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/announcements/save_sub_accounts_cannot_change_offers', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchMessages({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/announcements/messages_list')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push(res.data.message);
                } else {
                    commit('SET_MESSAGES_DATA', res.data)
                }
            })
            .catch(error => console.log(error))
    },
    saveMessagesSub({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/announcements/save_messages', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    sendAnnouncementsGetters: state => {
        return state.sendAnnouncementsData;
    },
    triggersGetters: state => {
        return state.triggersData;
    },
    messageGetters: state => {
        return state.messageData;
    },

}
export default {
    state,
    mutations,
    actions,
    getters
}

